import { render, staticRenderFns } from "./PeriodSwitcher.vue?vue&type=template&id=4798af86&scoped=true&"
import script from "./PeriodSwitcher.vue?vue&type=script&lang=js&"
export * from "./PeriodSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./PeriodSwitcher.vue?vue&type=style&index=0&id=4798af86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4798af86",
  null
  
)

export default component.exports